import { gql } from '@apollo/client';

const GET_CATS = gql`
  query getCats {
    getCats {
      _id
      catname
    }
  }
`;
const GET_MY_LIST_USERS_CHATS = gql`
  query getMyListUsersChats {
    getMyListUsersChats {
      _id
      name
      avatar
      lastVisit
      unreadCount
      lastMessage {
        _id
        text
        file
        createdAt
        unreadCount
        author {
          _id
          name
          avatar
        }
      }
    }
  }
`;
const GET_CAT = gql`
  query getCat($id: ID!) {
    getCat(_id: $id) {
      _id
      catname
      posts {
        _id
        iconPost
        title
        createdAt
        viewsCount
        likesCount
        dislikesCount
        commentCount
        tags
        author{
          _id
          name
        }
      }
    }
  }
`;

const GET_COMMENTS = gql`
  query getComments($post: String!) {
    getComments(post: $post) {
      _id
      text
      post {
        _id
        title}
        createdAt
        author{
          _id
          name
        }
    }
  }
`;

const GET_USER_MESSAGES = gql`
  query getUserMessages($addressee: [String!], $users: [ID!]) {
    getUserMessages(addressee: $addressee, users: $users) {
      _id
      text
      file
      read
      createdAt
      likesCount
      dislikesCount
      userLike
      author {
        _id
        avatar
        name
      }
    }
  }
`;

const GET_UNREAD_MESSAGES_COUNT = gql`
  query unreadMessagesCount {
    getUnreadMessagesCount
  }
`;

const GET_COMMENT_COUNT = gql`
  query commentCount($post: String!) {
    getCommentCount(post: $post)
  }
`;

const GET_USER = gql`
  query getUser($id: ID!) {
    getUser(_id: $id) {
      _id
      name
        family { 
        _id
        name
      }
      posts {
        _id
        title
        viewsCount
        createdAt
        body
        category{
          _id
          catname
        }
      }
    }
  }
`;

const GET_NOTES = gql`
  query postFeed($cursor: String, $limit: Int, $qualifier: String) {
    postFeed(cursor: $cursor, limit: $limit, qualifier: $qualifier) {
      cursor
      hasNextPage
      posts {
        _id
        title
        iconPost
        imageUrl
        imageUrl2
        imageUrl3
        imageUrl4
        scriptUrl
        createdAt
        category { _id catname }
        viewsCount
        body
        body2
        body3
        body4
        likesCount
        dislikesCount
        commentCount
        tags
        externalSource { icon url }
        comments { _id text likesCount dislikesCount }
        author { _id name }
      }
    }
  }
`;

const GET_HOME_NOTES = gql`
  fragment HomePostFields on postFeed {
    posts {
      _id
      title
      iconPost
      imageUrl
      imageUrl2
      imageUrl3
      imageUrl4
      scriptUrl
      createdAt
      viewsCount
      commentCount
      tags
      externalSource { url }
      author { name }
    }
  }
  query homePostFeed {
    technology: postFeed(tag: "Технологии", limit: 7) { ...HomePostFields }
    main: postFeed(tag: "Главное", limit: 7) { ...HomePostFields }
    events: postFeed(tag: "События", limit: 7) { ...HomePostFields }
    economy: postFeed(tag: "Экономика", limit: 7) { ...HomePostFields }
    people: postFeed(tag: "Люди", limit: 7) { ...HomePostFields }
    incidents: postFeed(tag: "Происшествия", limit: 7) { ...HomePostFields }
    realEstate: postFeed(tag: "Недвижимость", limit: 7) { ...HomePostFields }
    design: postFeed(tag: "Дизайн", limit: 7) { ...HomePostFields }
  }
`;

const GET_MY_POST = gql`
  query me {
    me {
      _id
      name
      email
      isAdmin
      posts {
        _id
        title
        iconPost
        imageUrl2
        imageUrl3
        imageUrl4
        createdAt
        viewsCount
        commentCount
        category {
          _id
          catname
        }

      }
    }
  }
`;

const GET_FIRST_POST = gql`
  query postFirst {
    postFirst {
      title
      scriptUrl
      viewsCount
      category {
        catname
      }
      author {
        name
      }
    }
  }
`;

const GET_ME = gql`
  query me {
    me {
      _id
      name
      email
      family {
        _id
        name
      }
      avatar
      bio
      isAdmin
      messages {
        _id
        text
        createdAt
        author {
          _id
          name
        }
      }
      posts {
        _id
        title
        iconPost
        imageUrl
        imageUrl2
        imageUrl3
        imageUrl4
        scriptUrl
        createdAt
        updatedAt
        viewsCount
        likesCount
        dislikesCount
        commentCount
        tags
        category {
          _id
          catname
        }
        body
          body4
        body2
        body3
      }
      comments {
        _id
        text
        createdAt
        post {
          _id
          title
        }
        author {
          _id
          name
        }
      }
    }
  }
`;

const GET_NAV_USER = gql`
  query getNavUser {
    me {
      _id
      name
      avatar
      isAdmin
    }
  }
`;

const GET_POST = gql`
  query getPost($id: ID!) {
    getPost(_id: $id) {
      _id
      title
      iconPost
      imageUrl
      imageUrl2
      imageUrl3
      imageUrl4
      scriptUrl
      externalSource {
        icon
        url
      }
      tags
      createdAt
      updatedAt
      viewsCount
      likesCount
      dislikesCount
      category {
        _id
        catname
      }
      body
      body2
      body3
      body4
      author {
        _id
        name
        email
      }
      commentCount
        comments {
        _id
        text
        likesCount
        dislikesCount
          createdAt
          post {
            _id
            title
          }
          author{
        _id
        name}
        }
    }
  }
`;

const GET_POSTS = gql`
  query getPosts {
    getPosts {
      _id
      title
      iconPost
      imageUrl
      imageUrl2
      imageUrl3
      imageUrl4
      scriptUrl
      createdAt
      updatedAt
      viewsCount
      category {
        _id
        catname
      }
      body
      body2
      body3
      body4
      tags
      author {
        _id
        name
        email
      }
      commentCount
    }
  }
`;

const GET_USERS = gql`
  query getUsers {
    getUsers {
      _id
      name
      email
      telephone
      avatar
    }
  }
`;

const IS_LOGGED_IN = gql`
  query isLoggedIn {
    isLoggedIn @client
  }
`;

export {
  GET_CATS,
  GET_CAT,
  GET_NOTES,
  GET_HOME_NOTES,
  GET_USER,
  GET_POSTS,
  GET_POST,
  GET_MY_POST,
  GET_ME,
  GET_COMMENTS,
  IS_LOGGED_IN,
  GET_USER_MESSAGES,
  GET_UNREAD_MESSAGES_COUNT,
  GET_COMMENT_COUNT,
  GET_MY_LIST_USERS_CHATS,
  GET_USERS,
  GET_NAV_USER
};
